import { getSsoSession } from 'auth/ssoClient'
import { useBrand } from 'config/brand'

/**
 * What a visitor sees with a session but no record: there is nothing to show
 * here on its own. The screens are entered from Kit19 Sales, which sends the
 * record inside the link. The developer test page lives at /testing and is not
 * linked from anywhere.
 */
export default function Landing() {
  useBrand('Entity View / Edit')
  const session = getSsoSession()
  return (
    <div className="app-shell">
      <div className="auth-error card">
        <h2>Open a record from the CRM</h2>
        <p>
          This app shows one lead or enquiry at a time. Use <strong>View entity</strong> or{' '}
          <strong>Edit entity</strong> on a record in the CRM and it opens here
          {session.isAuthenticated && session.displayName ? ` as ${session.displayName}` : ''}.
        </p>
      </div>
    </div>
  )
}
